import type { Op } from 'quill/core';
import React, { useState } from 'react';
import useIsLayoutSize from '../../post/utils/useIsLayoutSize';
import { LayoutSize } from '../../post/utils/useLayoutSize';
import { deltaOnlyContainWhitespace } from '../../utils/deltaHelpers';
import EditingOrganizationSummary from './EditingOrganizationSummary';
import * as styles from './OrganizationSummary.module.scss';
import ReadonlyOrganizationSummary from './ReadonlyOrganizationSummary';

const DEFAULT_VALUES = [{ insert: '\n\n' }];

interface OrganizationSummaryProps {
  summary: Op[] | null;
  onActivityOpen?: () => void;
}

const OrganizationSummary = ({
  summary,
  onActivityOpen,
}: OrganizationSummaryProps) => {
  const isMobile = useIsLayoutSize(LayoutSize.mobile);
  const [isEditing, setIsEditing] = useState(false);
  const isSummaryEmpty = !summary || deltaOnlyContainWhitespace(summary);

  if (isMobile && isEditing) {
    setIsEditing(false);
  }

  return (
    <header className={styles.container} aria-label="Organization Summary">
      {isEditing ? (
        <EditingOrganizationSummary
          summary={
            isSummaryEmpty
              ? DEFAULT_VALUES // Show at least two lines so user can see the placeholder
              : summary
          }
          onCancelEditing={() => setIsEditing(false)}
        />
      ) : (
        <ReadonlyOrganizationSummary
          summary={isSummaryEmpty ? null : summary}
          onStartEditing={() => setIsEditing(true)}
          onActivityOpen={onActivityOpen}
        />
      )}
    </header>
  );
};

export default OrganizationSummary;
